import styled from 'styled-components';

import { device } from 'styles/breakpoints';

export const VerifyEmailWrapper = styled.div`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.blue};
  overflow-x: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  .verify-header {
    display: flex;
    justify-content: center;
    > div {
      transition: all 0.3s ease;
      margin: 40px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &-logo {
      cursor: pointer;
      display: flex !important;
    }
    &-logo-mobile {
      cursor: pointer;
      display: none !important;
    }
  }
  @media ${device.tablet} {
    .verify-header {
      > div {
        margin: 20px 10px;
      }
      &-logo {
        display: none !important;
      }
      &-logo-mobile {
        display: flex !important;
      }
      &-actions {
        > p {
          display: none;
        }
      }
    }
  }
`;

export const VerifyEmailBoxWrapper = styled.div`
  display: flex;
  justify-content: center;
  .verify {
    width: 100%;
    max-width: 688px;
    background-color: ${({ theme }) => theme.colors.white};
    padding: 64px 30px 48px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    transition: all 0.3s ease;
    @media ${device.tablet} {
      max-width: 100%;
      padding: 48px 32px;
      min-height: calc(100vh - 65px);
      margin-bottom: 0;
    }
    p {
      color: ${({ theme }) => theme.colors.bluePallet1};
    }
    &-title {
      margin-top: 36px;
      margin-bottom: 24px;
      white-space: initial;
      max-width: 492px;
      width: 100%;
      > span {
        font-family: Walsheim-Bold;
      }
      @media ${device.tablet} {
        font-size: 28px;
        line-height: 36px;
      }
    }

    &-desc {
      margin: 24px 0;
      &-1,
      &-2 {
        white-space: normal;
      }
      &-1 {
        > span {
          font-family: Walsheim-Bold;
        }
      }
      &-resend {
        background-color: transparent;
        cursor: pointer;
        > p {
          color: ${({ theme }) => theme.colors.green};
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
    &-bottom {
      font-family: Walsheim-Bold;
      > a {
        color: ${({ theme }) => theme.colors.green};
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`;

export const VerifyEmailError = styled.p`
  color: ${({ theme }) => theme.colors.red};
`;
